import React from "react";
import moment from "moment";
import EventItem from "./EventItem";
import { detectOverlappingVisitas } from "./calendarUtils";

const CalendarCell = ({ value, dates, visibleTypes, handleItemClick }) => {
  const listData = dates
    ?.filter((date) => moment(date.Fecha).format("YYYY-MM-DD") === value.format("YYYY-MM-DD"))
    .filter((item) => visibleTypes.includes(item.Tipo));

  if (!listData || listData.length === 0) return null;

  const visitas = listData.filter((item) => item.Tipo === "visita");
  const otherItems = listData.filter((item) => item.Tipo !== "visita");

  const sortedVisitas = visitas.sort((a, b) => {
    if (!a.Hora1 || !b.Hora1) return 0;
    return moment(a.Hora1, "HH:mm").diff(moment(b.Hora1, "HH:mm"));
  });

  const overlappingPairs = detectOverlappingVisitas(visitas);
  const overlappingIds = new Set();
  overlappingPairs.forEach((pair) => {
    overlappingIds.add(pair[0]);
    overlappingIds.add(pair[1]);
  });

  const hasOverlaps = overlappingIds.size > 0;

  return (
    <div className="calendar-events">
      {sortedVisitas?.map((item, index) => {
        const isOverlapping = overlappingIds.has(item.id);
        return <EventItem key={`visita-${index}`} item={item} isOverlapping={isOverlapping} hasOverlaps={hasOverlaps} handleItemClick={handleItemClick} />;
      })}
      {otherItems?.map((item, index) => (
        <EventItem key={`other-${index}`} item={item} handleItemClick={handleItemClick} />
      ))}
    </div>
  );
};

export default CalendarCell;
